/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { DialogActions, Button } from "@mui/material";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";

const DocumentDialogTopActions = (props) => {

    const selectTab = props.selectTab;
    const ctx = useContext(DocumentEditContext);
    const { MODES } = ctx;
    
    const selectGalleryTab = (choice) => {
        selectTab(choice);
    };
    
    return (
        <Fragment>
            <DialogActions
                className="simplicity-document-selector-window-tabs"
                style={{  }}
            >
                <Button onClick={() => selectGalleryTab(MODES.SELECT)} >
                    <GridViewOutlinedIcon />
                    Documents
                </Button>
                
                <Button onClick={() => selectGalleryTab(MODES.UPLOAD)} >
                    <FileUploadIcon />
                    Upload
                </Button>
                
            </DialogActions>
        </Fragment>
    );
};

export { DocumentDialogTopActions };
